module.exports = __webpack_public_path__ + "img/icon-next-light.d4a1d41f.svg";